module.exports = __webpack_public_path__ + "img/icon_back.7b57ead5.svg";